// Ocultar BreadCrumbs de Landings

(() => {
  const landingsURL = [
    "/pages/comodidad-para-el-planeta",
    "/pages/proposito-de-los-crocs",
    "/pages/comodidad-para-nuestras-comunidades",
    "/pages/comodidad-para-todas-las-personas",
  ];
  const url = window.location.href;
  const breadcrumbs = document.getElementById("shopify-section-breadcrumbs");
  if (landingsURL && breadcrumbs && url) {
    landingsURL.forEach((landingURL) => {
      if (url.includes(landingURL)) {
        breadcrumbs.remove();
      }
    });
  }
})();
